import { DefaultService } from '@/services/DefaultService';

export default class ExportacaoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }
    
    // enviarEmail(idexportacao,mail) {
    //     return this._http.post(`${this._env}/sendmail/${idexportacao}/export.json`, mail, this._headers).then(res => {
    //         return res.body;
    //     }, err => {
    //         this.verifyError(err);
    //         throw err;
    //     });
    // }
}